
export const ProfileState: ProfileStateType = {
  id: '',
  fullName: '',
  rawImage: '',
  interest: [],
  language: [],
  profileImage: '',
  email: '',
  linkedinId: '',
  resumeUrl: '',
  githubUrl: '',
  designation: '',
  streetAddress: '',
  phoneNumber: [],
  studentId: '',
  dob: 0,
  gender: '',
  country: '',
  skills: [],
  summary: '',
  experienceDetails: [],
  educationDetails: [],
  accomplishments: [],
  certificateDetails: [],
  socialAccountsDetails: []
};

export interface ProfileStateType {
  id:                    string;
  fullName:              string;
  email:                 string;
  dob:                   number;
  country:               string;
  linkedinId:            string;
  githubUrl:             string;
  rawImage:              string;
  resumeUrl:             string;
  skills:                string[];
  interest:              any[];
  language:              any[];
  profileImage:          string;
  phoneNumber:           PhoneNumber[];
  studentId:             string;
  streetAddress:         string;
  designation:           string;
  summary:               string;
  gender:                string;
  certificateDetails:    CertificateDetail[];
  educationDetails:      EducationDetail[];
  experienceDetails:     ExperienceDetail[];
  socialAccountsDetails: any[];
  accomplishments:       Accomplishment[];
}

export interface Accomplishment {
  id:                      string;
  studentName:             string;
  programName:             string;
  organizationName:        string;
  programCoordinatorNames: string[];
  courseNames:             any[];
  completedDate:           number;
  certificateUniqueCode:   string;
  certificateOf?:          string;
  courseName?:             string;
}

export interface CertificateDetail {
  id:                     string;
  certificationUrl:       string;
  achievementType:        string;
  certificationName:      string;
  certificationAuthority: string;
  licenceNumber:          string;
  certificationDate:      string;
}

export interface EducationDetail {
  academicDegree: string;
  collegeName:    string;
  startDate?:     string;
  endDate?:       string;
  id:             string;
  currentStudy?:  boolean;
  gpa?:           number;
}

export interface ExperienceDetail {
  id:             string;
  companyName:    string;
  designation?:   string;
  startDate?:     string;
  endDate?:       string;
  jobDescription: string;
  currentJob?:    boolean;
}

export interface PhoneNumber {
  id:           string;
  phoneNumber:  number | null;
  dialCode:     null | string;
  phoneCountry: null | string;
}

export type DetailType = Accomplishment | EducationDetail | ExperienceDetail | CertificateDetail;


export const isEducationDetail = (detail: any) : detail is EducationDetail => {
    return typeof detail.collegeName === 'string';
}

export const isExperienceDetail = (detail: any) : detail is ExperienceDetail => {
  return typeof detail.companyName === 'string';
}

export const isCertificateDetail = (detail: any) : detail is CertificateDetail => {
  return typeof detail.certificationUrl === 'string';
}